import { Component, inject } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';

import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { AvatarComponent } from '@progress/kendo-angular-layout';
import { SVGIcon, menuIcon, paletteIcon } from '@progress/kendo-svg-icons';

import { BreadcrumbService } from '../services/breadcrumb.service';
import { Observable, map } from 'rxjs';
import { AuthService, UiUser } from '../auth.service';

@Component({
  selector: 'app-header-component',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  imports: [
    SVGIconComponent,
    AvatarComponent,
    NgIf,
    AsyncPipe
  ]
})
export class HeaderComponent {
  private _breadcrumbService = inject(BreadcrumbService);
  private auth = inject(AuthService);

  public menuIcon: SVGIcon = menuIcon;
  public paletteIcon: SVGIcon = paletteIcon;

  user$: Observable<UiUser | null> = this.auth.user$;

  public pageTitle() {
    return this._breadcrumbService.pageTitle();
  }

  login() { this.auth.loginRedirect(); }
  //logout() { this.auth.logoutRedirect(); }

  avatarSrc$ = this.user$.pipe(
    map(u => u?.photoUrl?.trim() ? 'assets/user.png' : 'assets/user.png')
  );
}
